import { request } from '@/shared/api/http-client'
import { emptyEnvelopeSchema } from '@/shared/api/api-contract'
import {
  authTokenEnvelopeSchema,
  fileQuotaEnvelopeSchema,
  memberEnvelopeSchema,
  memberRegistrationEnvelopeSchema,
  pointBalanceEnvelopeSchema,
  pointTransactionsEnvelopeSchema,
} from './member-contract'

export function loginMember(email: string, password: string) {
  return request('/open/member/login', { method: 'POST', body: { email, password }, schema: authTokenEnvelopeSchema })
}

export function sendRegisterCode(email: string) {
  return request('/open/member/email-code/register', { method: 'POST', body: { email }, schema: emptyEnvelopeSchema })
}

export function getMemberRegistration() {
  return request('/open/member/registration', { method: 'GET', schema: memberRegistrationEnvelopeSchema })
}

export function registerMember(email: string, code: string, password: string) {
  return request('/open/member/register', { method: 'POST', body: { email, code, password }, schema: emptyEnvelopeSchema })
}

export function sendResetPasswordCode(email: string) {
  return request('/open/member/password/reset-code', { method: 'POST', body: { email }, schema: emptyEnvelopeSchema })
}

export function resetMemberPassword(email: string, code: string, newPassword: string) {
  return request('/open/member/password/reset', { method: 'POST', body: { email, code, newPassword }, schema: emptyEnvelopeSchema })
}

export function logoutMember() {
  return request('/member/auth/logout', { method: 'POST', schema: emptyEnvelopeSchema })
}

export function getCurrentMember() {
  return request('/member/me', { method: 'GET', schema: memberEnvelopeSchema })
}

export function updateCurrentMember(data: { nickname?: string; avatarFileId?: number | null }) {
  return request('/member/me', { method: 'PATCH', body: data, schema: memberEnvelopeSchema })
}

export function changeMemberPassword(oldPassword: string, newPassword: string) {
  return request('/member/me/password/change', { method: 'POST', body: { oldPassword, newPassword }, schema: emptyEnvelopeSchema })
}

export function deleteMemberAccount(password: string) {
  return request('/member/me', { method: 'DELETE', body: { password }, schema: emptyEnvelopeSchema })
}

export function getPointBalance() {
  return request('/member/points', { method: 'GET', schema: pointBalanceEnvelopeSchema })
}

export function getPointTransactions(page = 1, size = 20) {
  return request(`/member/point-transactions?page=${page}&size=${size}`, { method: 'GET', schema: pointTransactionsEnvelopeSchema })
}

export function getFileQuota() {
  return request('/files/quota', { method: 'GET', schema: fileQuotaEnvelopeSchema })
}
